import styled from "styled-components";

export const MobileStyled = styled.div`
.kuda-dark--bg {
    background-color: var(--blackColor) !important;
}
.kuda-cta-dark {
    background: #FFFFFF !important;
    color: #000000  !important;
    margin-left: 8px;
    min-width: 100px
}
`